document.addEventListener('DOMContentLoaded', function () {
    const menuItems = document.querySelectorAll('.list-menu-item-wrapper');
    const meganav = document.querySelector('.site-nav.meganav');
    const closeButton = document.querySelector('.meganav__close');
    const primary_links = document.querySelectorAll('.meganav__link');
    const secondary_links = document.querySelectorAll('.meganav__column.meganav__column--secondary');
    const meganav__sublinks = document.querySelectorAll('.meganav__sublink');
    const terziary_links = document.querySelectorAll('.meganav__column.meganav__column--terziary');

    menuItems.forEach((item) => {
        const link = item.querySelector('a');

        if (link && link.getAttribute('href').includes('#')) {
            link.addEventListener('click', function () {
                meganav.classList.toggle('active');
            });
        }
    });

    primary_links.forEach((primary_link) => {
        primary_link.addEventListener('mouseenter', function (event) {
            event.preventDefault();

            primary_links.forEach((link) => {
                link.classList.remove('active');
            });
            primary_link.classList.toggle('active');

            secondary_links.forEach((secondary_link) => {
                secondary_link.style.display = 'none';
            });

            secondary_links.forEach((secondary_link) => {
                if (primary_link.getAttribute('data-primary-id') == secondary_link.getAttribute('data-primary-id')) {
                    secondary_link.style.display = 'flex';
                }
            });
        });
    });

    meganav__sublinks.forEach((meganav__sublink) => {
        {
            meganav__sublink.addEventListener('mouseenter', function (event) {
                event.preventDefault();

                meganav__sublinks.forEach((link) => {
                    link.classList.remove('active');
                });
                meganav__sublink.classList.toggle('active');

                terziary_links.forEach((terziary_link) => {
                    terziary_link.style.display = 'none';
                });

                terziary_links.forEach((terziary_link) => {
                    if (meganav__sublink.getAttribute('data-toggle') === terziary_link.getAttribute('data-toggle')) {
                        terziary_link.style.display = 'block';
                    }
                });
            });
        }
    });

    if (closeButton) {
        closeButton.addEventListener('click', function () {
            meganav.classList.remove('active');
            secondary_links.forEach((secondary_link) => {
                secondary_link.style.display = 'none';
            });
        });
    }
});

window.addEventListener('scroll', function () {
    const headerwrapper = document.querySelector('.header-wrapper');
    const bannermedia = document.querySelector('.random-image-blocks');

    if (bannermedia) {
        const bannerBottom = bannermedia.offsetTop + bannermedia.offsetHeight;
        if (window.scrollY > bannerBottom) {
            headerwrapper.classList.add('white-bg');
        } else {
            headerwrapper.classList.remove('white-bg');
        }
    }
});
